import React, { useMemo } from "react";
import { get } from "lodash";
import cn from "classnames";
import { Popover, Text, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";

import constants from "utils/constants";

import "./PopoverCell.less";

interface Props {
    dataKey: string;
    rowData: any;

    className?: string;
}

const PopoverCell: React.FC<Props> = ({
    dataKey,
    rowData,
    className,
}: Props) => {
    const { t } = useTranslation();

    const value = get(rowData, dataKey, t(`unknown`)) ?? t(`unknown`);

    const hintPopover = useMemo(
        () => (
            <Popover className={"popover-cell"}>
                <span className={className}>{value}</span>
            </Popover>
        ),
        [className, value]
    );

    return (
        <Whisper
            trigger="hover"
            placement={"topStart"}
            delay={constants.defaultDelay}
            speaker={hintPopover}
            enterable
        >
            <Text className={cn("popover-cell__text", className)}>{value}</Text>
        </Whisper>
    );
};

export default PopoverCell;
